import useEvent from "./use-event";

const useSingleEvent = useEvent;
export default useSingleEvent;
